export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    navigation: {
      type: Object,
      required: true,
    },
  },
  emits: ['close-menu'],
  data() {
    return {
      mobileAccordionStates: {},
    }
  },
  methods: {
    toggleMobileAccordion(index) {
      this.$set(
        this.mobileAccordionStates,
        index,
        !this.mobileAccordionStates[index]
      )
    },
    getAccordionStyle(index) {
      return {
        maxHeight: this.mobileAccordionStates[index]
          ? this.$el.querySelectorAll('.mobile-accordion-content')[index]
              .scrollHeight + 'px'
          : '0',
        padding: this.mobileAccordionStates[index] ? '1.5rem 0 1.5rem 0' : '0',
      }
    },
  },
}
